<div mat-dialog-container>
  <div class="close-row">
    <a (click)="close()">
      <img
        class="close-icon"
        src="assets/images/shared/Icon - Close - Active.svg"
      />
    </a>
  </div>
  <div mat-dialog-content>
    <div class="body-modal">
      <div class="it-helpdesk-modal-img">
        <img src="assets/images/shared/Illustration - Helpdesk.svg" />
      </div>

      <div class="it-helpdesk-modal-title modal-title-font title">
        <span>{{ helpdeskTitle }}</span>
      </div>

      <div class="modal-text-font">
        <span>
          {{ helpdeskContactPrefix }}
          <a href="tel:+60322641006">
            <b class="bolded fw-semi-bold">+603 4065 7065</b>
          </a>
          {{ helpdeskContactJoiner }}
          <a href="mailto:alpha.helpdesk@allianz.com.my">
            <b class="bolded fw-semi-bold">alpha.helpdesk&#64;allianz.com.my</b>
          </a>
        </span>
      </div>
    </div>
  </div>
</div>
